export default __webpack_public_path__ + "static/media/BLC_BG.c23f232d.png";